import { getMessages } from '../../../../../../../../store/constants';

export const MAX_BOARD_LOGO_FILE_SIZE = 500 * 1024; // 500 KB

export const BOARD_LOGO_WRONG_FILE_SIZE_TEXT = getMessages().getText('popup.dashboard.logo.too_large');
export const BOARD_LOGO_WRONG_FILE_TYPE_TEXT = getMessages().getText('popup.dashboard.image_mime_mismatch');
